import React, { useContext } from 'react'
import { withRouter } from 'react-router-dom'
import SidebarSubmenu from './SidebarSubmenu'
import SidebarContext from './SidebarContext'

const isPathMatch = (location, url) => {
  if (!url || url === '#') return false
  const [urlPath, urlSearch] = url.split('?')
  if (urlPath === '/') return location.pathname === '/'
  const pathMatches = location.pathname === urlPath || location.pathname.startsWith(`${urlPath}/`)
  if (!pathMatches) return false
  if (urlSearch) return location.search === `?${urlSearch}`
  return true
}

const SidebarItem = ({
  item,
  expanded,
  isSubmenuOpen,
  onSubmenuOpen,
  onSubmenuClose,
  onNavigate,
  history,
  location
}) => {
  const { logout } = useContext(SidebarContext)

  if (item.isDisplay) {
    return (
      <li className="app-sidebar__item app-sidebar__item--display" title={item.name}>
        {item.icon && (
          <span className="app-sidebar__item-icon">
            <img src={item.icon} alt="" />
          </span>
        )}
        <span className="app-sidebar__item-label">{item.name}</span>
      </li>
    )
  }
  const hasChildren = Array.isArray(item.children) && item.children.length > 0
  const childActive =
    hasChildren && item.children.some((c) => isPathMatch(location, c.url))
  const isActive = isPathMatch(location, item.url) || childActive

  const className = [
    'app-sidebar__item',
    isActive ? 'is-active' : '',
    item.disabled ? 'is-disabled' : '',
    hasChildren ? 'has-children' : ''
  ]
    .filter(Boolean)
    .join(' ')

  const handleClick = (e) => {
    e.preventDefault()
    if (item.disabled) return
    if (hasChildren) {
      if (isSubmenuOpen) {
        onSubmenuClose()
      } else {
        onSubmenuOpen()
      }
      return
    }
    if (item.action === 'logout') {
      if (logout) logout()
      return
    }
    if (!item.url || item.url === '#') return
    history.push(item.url)
    if (onNavigate) onNavigate()
  }

  return (
    <li
      className={className}
      onMouseEnter={() => hasChildren && onSubmenuOpen()}
      onMouseLeave={() => hasChildren && onSubmenuClose()}
    >
      <a href={item.url || '#'} onClick={handleClick}>
        <span className="app-sidebar__item-icon">
          {item.icon && item.icon.startsWith('/') ? (
            <img src={item.icon} alt="" />
          ) : item.icon ? (
            <i className={item.icon} />
          ) : null}
        </span>
        <span className="app-sidebar__item-label">{item.name}</span>
        {item.badge && <span className="app-sidebar__item-badge">{item.badge}</span>}
        {!item.disabled && hasChildren && (
          <span className="app-sidebar__item-chevron">
            <i className="fa fa-chevron-right" />
          </span>
        )}
      </a>
      {hasChildren && isSubmenuOpen && expanded && (
        <SidebarSubmenu
          title={item.name}
          items={item.children}
          onNavigate={onNavigate}
        />
      )}
    </li>
  )
}

export default withRouter(SidebarItem)
